import { DynamicTab } from "../../../../components/Page";
import { RuvnlTitle } from "../../../DemoState/components";
import SecondaryHeader from "../../../DemoState/Demand/SecondaryHeader";
import { TabSwitcher } from "../../../DemoState/Raj_Dashboard";
import { ExchangeDataTabs } from "../../../Rajasthan/Demand/Data";
import ExchangeMetricsForm from "./PriceAnalysisForm";
// import ExchangeMetricsPage from "./PriceAnalysisForm";

export function ExchangeMetrics() {
  return (
    <div className="flex flex-col gap-2 m-3 justify-between">
      <SecondaryHeader showViewMode={false} />
      <ExchangeMetricsForm />
</div>
  );
}
